import { Injectable } from "@angular/core";
import { Integration } from "app/org-dashboard/org-integration-elogbooks/org-integration-elogbooks.component";

@Injectable({
  providedIn: "root",
})
export class ScheduleService {

  static getDays() {

    return ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  };

}


export class EquipmentSchedule {
  id: number;
  title: string;
  days: IEquipmentScheduleItem[];

  constructor() {
    // seed the days with defaults
    this.days = ScheduleService.getDays().map(day => {
      return {
        timeOn: null,
        timeOff: null,
        day: day
      }
    });
  }
}

export interface IEquipmentScheduleItem {
  timeOn: string;
  timeOff: string;
  day: string;
}

